import React, { useEffect } from "react";
import awsConfig from "../aws-exports";

const Logout = () => {
  useEffect(() => {
    console.log("Logging out from Cognito...");

    // Clear local tokens and cookies
    localStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
    });

    // Redirect to Cognito logout endpoint
    const logoutUrl = `https://${awsConfig.authority}/logout?client_id=${awsConfig.client_id}&logout_uri=${encodeURIComponent(awsConfig.redirectSignout_uri)}`;
    window.location.href = logoutUrl;
  }, []);

  return <p>Logging out...</p>;
};

export default Logout;
